<template lang="pug">

div

    //- Navigation
    navigation

    //- Headline
    //- .ui.attached.segment
    //-     .ui.two.column.centered.middle.aligned.grid
    //-         .column
    //-             h2.ui.header
    //-                 i.address.book.icon
    //-                 .content Adressen
    //-         .ui.form.column
    //-             input(type='text' placeholder='Ihr Suchbegriff')

    //- Filter
    .ui.secondary
        filter-bar(v-bind:counts="$store.getters['addresses/counts']")

    //- Message wenn keine Adressen gefunden
    .ui.bottom.icon.message.no-users(v-if='addressModels.length === 0')
        i.meh.icon
        .content: .header Keine Adressen gefunden

    template(v-else)

        //- Adressen
        table.ui.fixed.table
            thead
                tr
                    th.four.wide Firma
                    th.three.wide Typ
                    th.three.wide Unternehmen
                    th.two.wide Stadt
                    th.two.wide Bundesland
                    th.two.wide Land
            tbody
                tr(
                    is="row"
                    v-for="addressModel in addressModels"
                    v-bind:key="addressModel.id"
                    v-bind:address-model="addressModel"
                    v-bind:company-models="findCompanyModelsByLinks(addressModel.companies)"
                    v-bind:country-model="findCountryModelById(addressModel.country)"
                    v-bind:state-model="findStateModelById(addressModel.state)"
                )

        //- Pagination
        .ui.bottom.secondary
            .ui.two.column.grid
                .middle.aligned.column
                    .ui.form
                        .inline.fields(style='margin: 0')
                            label Zeilen pro Seite:
                            .field
                                select.ui.selection.dropdown(ref='pageSizeDropdown')
                                    option(v-for='n in pageSizeOptions' v-bind:key='n' v-bind:value='n') {{ n }}
                .right.aligned.middle.aligned.column(v-if='totalPages > 1')
                    .ui.pagination.menu
                        a.icon.item(v-bind:class='{ disabled: currentPage === 1 }' v-on:click='currentPage > 1 && (currentPage -= 1)')
                            i.left.chevron.icon
                        a.item(
                            v-for='page in totalPages'
                            v-bind:key='page'
                            v-bind:class='{ active: page === currentPage }'
                            v-on:click='currentPage = page'
                        ) {{ page }}
                        a.icon.item(v-bind:class='{ disabled: currentPage === totalPages }' v-on:click='currentPage < totalPages && (currentPage += 1)')
                            i.right.chevron.icon

</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    import store from '@/store'
    import FilterBar from '@/components/addresses/FilterBar'
    import Navigation from '@/components/addresses/Navigation'
    import Row from '@/components/addresses/table/Row'

    async function load_page(route, { page = 0, size = 20 } = {}) {
        const filter  = route.query.filter  || null
        const company = route.query.company ? Number(route.query.company) : null

        const { addresses, total } = await store.dispatch('addresses/loadPage', { page, size, filter, company })

        const companyIds = [...new Set(addresses.reduce((ids, a) => ids.concat((a.companies || []).map(link => link.company)), []))]
        const countryIds = [...new Set(addresses.map(a => a.country).filter(Boolean))]
        const stateIds   = [...new Set(addresses.map(a => a.state).filter(Boolean))]

        await Promise.all([
            ...companyIds.map(id => store.dispatch('companies/loadOne', { id })),
            ...countryIds.map(id => store.dispatch('countries/loadOne', { id })),
            ...stateIds  .map(id => store.dispatch('states/loadOne',    { id })),
        ])

        return { addresses, total }
    }

    // noinspection JSUnusedLocalSymbols
    export default {

        components: { FilterBar, Navigation, Row },

        beforeRouteEnter(to, from, next) {
            load_page(to).then(({ addresses, total }) => next(vm => {
                vm.pageAddresses  = addresses
                vm.filteredTotal  = total
            }))
        },

        beforeRouteUpdate(to, from, next) {
            this._routeChanging = true
            this.currentPage = 1
            load_page(to, { size: this.itemsPerPage }).then(({ addresses, total }) => {
                this.pageAddresses  = addresses
                this.filteredTotal  = total
                this._routeChanging = false
                next()
            })
        },

        created() {
            this._routeChanging = false
        },

        mounted() {
            this._initDropdown()
        },

        updated() {
            this._initDropdown()
        },

        data() {
            return {
                currentPage:     1,
                filteredTotal:   0,
                itemsPerPage:    25,
                pageAddresses:   [],
                pageSizeOptions: [25, 50, 100, 250],
            }
        },

        watch: {
            currentPage() {
                if (!this._routeChanging) {
                    this.loadCurrentPage()
                }
            },
            itemsPerPage() {
                if (this.currentPage === 1) {
                    this.loadCurrentPage()
                } else {
                    this.currentPage = 1
                }
            },
        },

        methods: {

            _initDropdown() {
                const el = this.$refs.pageSizeDropdown
                if (!el || $(el).data('module-dropdown')) return
                $(el).dropdown({
                    onChange: (value) => {
                        const n = parseInt(value, 10)
                        if (n !== this.itemsPerPage) {
                            this.itemsPerPage = n
                            this.currentPage = 1
                        }
                    }
                })
            },

            async loadCurrentPage() {
                const { addresses, total } = await load_page(this.$route, {
                    page: this.currentPage - 1,
                    size: this.itemsPerPage,
                })
                this.pageAddresses = addresses
                this.filteredTotal = total
            },

            findCompanyModelsByLinks(links) {
                return (links || []).map(link => store.getters['companies/all'].find(c => c.id === link.company)).filter(Boolean)
            },

            findCountryModelById(id) {
                return store.getters['countries/all'].find(c => c.id === id)
            },

            findStateModelById(id) {
                return store.getters['states/all'].find(s => s.id === id)
            },

        },

        computed: {

            addressModels() {
                return this.pageAddresses
            },

            totalPages() {
                return Math.ceil(this.filteredTotal / this.itemsPerPage)
            },

        }

    }

</script>
